import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { Element } from "../../components";
import IconRenderer from "../../components/common/IconRenderer";
import { cn } from "../../utils";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		attributes: {
			icon,
			link,
			presets,
			contentHorizontalAlign,
			className,
			cssID,
			clientId,
		},
	} = props;

	return (
		<div
			id={cssID ? cssID : null}
			className={cn(
				`mzb-icon-block mzb-icon-${clientId}`,
				contentHorizontalAlign && `mzb-${contentHorizontalAlign}`,
				className
			)}
		>
			<Element
				tagName="a"
				htmlAttrs={{
					className: cn("mzb-outside-icon", "mzb-icon-link"),
					href: link && link.url ? link.url : null,
					target: link && link.newTab ? "_blank" : null,
					rel: link && link.newTab ? "noopener" : null,
				}}
			>
				<span
					className={cn(
						`mzb-icon-wrapper`,
						presets && `mzb-${presets}`,
						className
					)}
				>
					<IconRenderer name={icon} />
				</span>
			</Element>
		</div>
	);
};

export default Save;
